import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'
import Editor from '@monaco-editor/react'
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  InputGroup,
  ListGroup,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAd,
  faCircleExclamation,
  faDisplay,
  faLink,
  faMinusCircle,
  faPlusCircle,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import apiServices from '../services/apiServices'
import { ToastContext } from '../components/ContextProvider'

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      size={size}
      show={show !== false}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-dai">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose(false)}>
          取消
        </Button>
        <Button variant="dai" onClick={() => handleClose(show)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const getSrcDoc = (adtag, values) => {
  let refined = adtag
  values.forEach((value) => {
    refined = refined.replaceAll(`{{ ${value.name} }}`, value.default)
  })
  return `<style>
          .text-title { height: 15px; width: 90%; background: #e7e7e7; border-radius: 5px; margin:10px auto; }
          .text-line  { height:  7px; width: 90%; background: #e7e7e7; margin:6px auto; }
          .text-ban1  { height:100px; width: 90%; background: #e7e7e7; margin:14px auto; }
          .text-line2 { height:  7px; width: 60%; background: #e7e7e7; margin:6px auto; }
        </style>
        <div style="position: relative;">
          <div style="display: flex; border-bottom: 1px solid #dee2e6; width: 300px; height: 55px; z-index: 0; margin-bottom: 1rem;">
            <div style="flex: 0 0 80%; display: flex; align-items: center; justify-content: flex-start; padding-left: 1rem;">
              <img src="https://www.wavenet.com.tw/wp-content/uploads/2019/02/wavnet-logo-b-s.jpg" style="width: 75%;" alt="Wavenet Logo" />
            </div>
            <div style="flex: 0 0 20%; display: flex; align-items: center; justify-content: center;">
              <i class="fa-solid fa-bars" style="text-align: end;"></i>
            </div>
          </div>
          <div class="text-title"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-ban1"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line2"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
        </div>

        <!-- 模擬 gam 嵌入碼顯示於網頁上的效果 (1x1 iframe 的廣告素材) -->
        <iframe
          id="ads-iframe"
          src="./bundle-ads.html"
          style="width: 1px; height: 1px; border: none;"
        ></iframe>

        <div style="position: relative;">
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <br />
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
          <div class="text-line"></div>
        </div>

        ${refined}
      `
}

function ContainerManager() {
  const { setToast } = useContext(ToastContext)
  const [containers, setContainers] = useState([])
  const getContainers = async () => {
    const res = await apiServices.data({
      path: 'container',
      method: 'get',
    })
    setContainers(res)
  }
  useEffect(() => {
    getContainers()
  }, [])

  const handleAddContainer = async (value) => {
    await apiServices.data({
      path: 'container',
      method: 'post',
      data: value,
    })
    getContainers()
  }
  const handleEditContainer = async (id, value) => {
    await apiServices.data({
      path: `container/${id}`,
      method: 'put',
      data: value,
    })
    getContainers()
  }
  const handleDeleteContainer = async (id) => {
    await apiServices.data({
      path: `container/${id}`,
      method: 'delete',
    })
    getContainers()
  }

  const [search, setSearch] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [current, setCurrent] = useState(null)
  const [form, setForm] = useState({
    name: '',
    adtag: '',
    values: [],
  })

  const filtered = containers.filter((c) => c.setting.name.includes(search))

  const openModal = (item = null) => {
    if (item) {
      setEditMode(true)
      setCurrent(item)
      setForm({
        name: item.setting.name,
        adtag: item.setting.adtag || '',
        values: item.setting.values || [],
      })
    } else {
      setEditMode(false)
      setCurrent(null)
      setForm({ name: '', adtag: '', values: [] })
    }
    setShowModal(true)
  }

  const [showWarn, setshowWarn] = useState({
    show: false,
    func: () => {},
  })

  const save = () => {
    const payload = { ...form }
    console.log(current)
    console.log(payload)
    if (editMode) {
      handleEditContainer(current.container_id, payload)
    } else {
      handleAddContainer(payload)
    }
    setShowModal(false)
  }

  const handleMount = (editor, monaco) => {
    const format = () => editor.getAction('editor.action.formatDocument').run()
    format() // 載入先排版
    editor.onDidBlurEditorText(format) // 離焦再排版
    editor.addCommand(
      monaco.KeyMod.CtrlCmd || monaco.KeyCode.KeyS,
      format // Ctrl/⌘+S 也排版
    )
  }

  return (
    <div className="p-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <InputGroup style={{ maxWidth: '300px' }}>
          <Form.Control
            placeholder="搜尋名稱"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
        <Button onClick={() => openModal()}>新增</Button>
      </div>

      <ListGroup>
        {filtered.map((c, i) => (
          <ListGroup.Item key={i} className="d-flex py-3">
            <p className="my-auto">{c.setting.name}</p>
            <FontAwesomeIcon
              onClick={() => openModal(c)}
              className="btn ms-auto"
              title="編輯"
              icon={faAd}
            />
            <FontAwesomeIcon
              onClick={() => {
                window.open(
                  `${window.origin}/api/container-preview?aid=${c.container_id}`
                )
              }}
              className="btn ms-3"
              title="預覽"
              icon={faDisplay}
            />
            <FontAwesomeIcon
              onClick={() => {
                const queryString =
                  c.setting.values && c.setting.values.length
                    ? `?${c.setting.values
                        .map((value) => `${value.name}=${value.default}`)
                        .join('&')}`
                    : ''
                const cb = navigator.clipboard
                cb.writeText(
                  `<script async type="text/javascript" charset="utf-8" src="${window.origin}/api/cad/${c.container_id}${queryString}"></script>`
                )
                setToast({
                  show: true,
                  text: '已 複 製 adtag 到 剪 貼 簿',
                })
              }}
              className="btn ms-3"
              title="取得tag"
              icon={faLink}
            />
            <FontAwesomeIcon
              onClick={() =>
                setshowWarn({
                  show: true,
                  func: () => handleDeleteContainer(c.container_id),
                })
              }
              className="btn ms-3"
              title="刪除tag"
              icon={faTrashAlt}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>

      <Modal show={showModal} onHide={() => setShowModal(false)} fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? '編輯容器' : '新增容器'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row
            style={{
              minHeight: '75vh',
              maxHeight: '75vh',
              height: '75vh',
            }}
          >
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>名稱</Form.Label>
                <Form.Control
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
              </Form.Group>
              {/* <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  value={form.adtag}
                  onChange={(e) => setForm({ ...form, adtag: e.target.value })}
                />
              </Form.Group> */}
              {/* <Form.Group className="mb-3">
                <Form.Label>欄位 2</Form.Label>
                <Form.Control
                  as="textarea"
                  value={form.style}
                  onChange={(e) => setForm({ ...form, style: e.target.value })}
                />
              </Form.Group> */}
              <Editor
                height="80%"
                language="html"
                path="snippet.html" /* ← 副檔名一定要 .html */
                defaultValue="<style></style>"
                onMount={handleMount}
                value={form.adtag}
                onChange={(e) => {
                  console.log(e)
                  setForm({ ...form, adtag: e })
                }}
                options={{
                  formatOnPaste: true,
                  formatOnType: false, // 讓排版集中在 format()
                  minimap: { enabled: false },
                  automaticLayout: true,
                }}
              />
            </Col>
            <Col className="h-100 overflow-auto" md={4}>
              <Form.Group className="mb-3 d-flex">
                <Form.Label>插入變數</Form.Label>
                <FontAwesomeIcon
                  className="ms-auto btn"
                  onClick={() => {
                    setForm({
                      ...form,
                      values: [
                        ...form.values,
                        { id: uuid(), name: 'new value', default: '' },
                      ],
                    })
                  }}
                  icon={faPlusCircle}
                />
              </Form.Group>
              {form.values.map((value, i) => (
                <Form.Group key={value.id} className="mb-3">
                  <Form.Label className="d-flex">
                    變數{i + 1}名稱
                    <FontAwesomeIcon
                      className="ms-auto btn"
                      onClick={() => {
                        setForm({
                          ...form,
                          values: form.values.filter((v) => v.id !== value.id),
                        })
                      }}
                      icon={faMinusCircle}
                    />
                  </Form.Label>
                  <Form.Control
                    value={value.name}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        values: form.values.map((v, j) =>
                          i === j
                            ? {
                                ...v,
                                name: e.target.value,
                              }
                            : v
                        ),
                      })
                    }
                  />
                  <Form.Label className="d-flex">預設值</Form.Label>
                  <Form.Control
                    value={value.default || ''}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        values: form.values.map((v, j) =>
                          i === j
                            ? {
                                ...v,
                                default: e.target.value,
                              }
                            : v
                        ),
                      })
                    }
                  />
                </Form.Group>
              ))}
            </Col>
            <Col md={4}>
              <iframe
                title="container-preview"
                srcDoc={getSrcDoc(form.adtag, form.values)}
                style={{
                  width: '100%',
                  height: '100%',
                  border: '1px solid #ccc',
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            取消
          </Button>
          <Button variant="primary" onClick={save}>
            儲存
          </Button>
        </Modal.Footer>
      </Modal>
      <Warn
        setting={{
          show: showWarn.show,
          handleClose: (value) => {
            if (value) showWarn.func()
            setshowWarn({
              show: false,
              func: () => {},
            })
          },
        }}
      />
    </div>
  )
}

Warn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default ContainerManager
